import { GetSessionV2Response } from "@endavaaccorplus/payments-common/schemas";

export const getPwpEligibleAttributes = (session: GetSessionV2Response) => {
  if (session.customer?.isPwpEligible == null) return "Unknown";
  return (session.purchaseAmount.points ?? 0) > 0 &&
    session.customer.isPwpEligible
    ? "Yes"
    : "No";
};
